import { render, staticRenderFns } from "./EmergingArtists.vue?vue&type=template&id=144d54f0&scoped=true&"
import script from "./EmergingArtists.vue?vue&type=script&lang=js&"
export * from "./EmergingArtists.vue?vue&type=script&lang=js&"
import style0 from "./EmergingArtists.vue?vue&type=style&index=0&id=144d54f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144d54f0",
  null
  
)

export default component.exports